/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

const MAX_DIGIT_COUNT = 8;

type TRangeValue = number | string;

export const isFilterRangeValueValid = (regExp: RegExp, value: TRangeValue): boolean => {
    if (!value) {
        return true;
    }
    return !!value.toString().match(regExp) && value.toString().length <= MAX_DIGIT_COUNT;
};

export const isFilterRangeRightValueGreater = (regExp: RegExp, leftValue?: TRangeValue, rightValue?: TRangeValue) => {
    if (!leftValue || !rightValue) {
        return true;
    } else {
        const from = leftValue.toString();
        const to = rightValue.toString();
        if (!regExp.test(from) || !regExp.test(to)) {
            return true;
        } else {
            return parseFloat(from) < parseFloat(to);
        }
    }
};

export const getFilterRangeRangeFilterValue = (valueFrom: TRangeValue, valueTo: TRangeValue): string => {
    const valueFromInt = parseInt(valueFrom as string);
    const valueToInt = parseInt(valueTo as string);
    if (!isNaN(valueFromInt) && !isNaN(valueToInt)) {
        return `${valueFrom} ... ${valueTo}`;
    } else if (!isNaN(valueFromInt) && isNaN(valueToInt)) {
        return `⩾ ${valueFrom}`;
    } else if (isNaN(valueFromInt) && !isNaN(valueToInt)) {
        return `⩽ ${valueTo}`;
    }
    return '';
};
